<template>
  <div>
    <el-form
      status-icon
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      ref="ruleForm"
      v-loading="formLoading"
      label-width="120px"
      class="carpo-form demo-ruleForm"
    >
      <VehicleSelect
        prop="vehicle_id"
        :model="ruleForm.vehicle_id"
        @update="ruleForm.vehicle_id = $event"
        :disabled="ruleForm.disabled"
        :multiple="true"
        :collapseTags="true"
        class="lg:col-span-2"
      />

      <el-form-item :label="$t('DATE_RANGE')" prop="dateRange">
        <date-picker
          v-model="ruleForm.dateRange"
          color="#151515"
          class="el-input__inner"
          type="date"
          range
          format="YYYY-MM-DD"
          display-format="jYYYY/jMM/jDD"
          :clearable="true"
          :editable="false"
          :placeholder="$t('SELECT_DATE_RANGE')"
          @change="formChanged"
          :max="maxDate"
        />
      </el-form-item>

      <el-form-item class="flex justify-end col-span-full mt-4">
        <slot></slot>
        <el-button type="success" @click="submitForm('ruleForm')">
          {{ $t('SEARCH') }}
        </el-button>
      </el-form-item>
    </el-form>

    <div v-if="result" class="flex justify-end">
      <el-button
        :loading="isDownloadLoading"
        type="primary"
        @click="downloadReport()"
      >
        {{ $t('DOWNLOAD_REPORT') }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { periodicReport, DownloadperiodicReport } from '@/api/reports'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'

export default {
  components: {
    VehicleSelect,
  },
  mixins: [jalaliToGregorian, gregorianToJalali],
  data() {
    return {
      result: null,
      isDownloadLoading: false,
      loading: true,
      formLoading: false,
      selectedId: null,
      ruleForm: {
        dateRange: null,
        vehicle_id: '',
        min_duration: '5',
        value1: [new Date(2021, 9, 10, 0, 0), new Date(2021, 9, 10, 23, 59)],
      },

      rules: {
        vehicle_id: {
          required: true,
          message: this.$i18n.t('REQUIRED_CHOOSE', {
            type: this.$i18n.t('VEHICLE_TITLE'),
          }),
          trigger: 'blur',
        },
        dateRange: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('DATE_RANGE'),
            }),
            trigger: 'blur',
          },
        ],

        value1: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('TIME'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    downloadReport() {
      this.isDownloadLoading = true
      const startDate = this.ruleForm.dateRange[0]
      const endDate = this.ruleForm.dateRange[1]

      const actionPayload = {
        company_vehicle: this.ruleForm.vehicle_id.join(','),
        date__lte: endDate,
        date__gte: startDate,
      }

      DownloadperiodicReport.api(actionPayload)
        .then((res) => {
          this.isDownloadLoading = false
          if (res) {
            var blob = new Blob([res], { type: 'application/octet-stream' })

            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            a.download = `periodic-report-CARPO.xlsx`
            document.body.appendChild(a)
            a.click()

            window.URL.revokeObjectURL(url)
          }
        })
        .catch((error) => {
          console.error('Download Error:', error)
        })
    },
    formChanged() {
      this.$emit('result', null)
      this.result = null
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        this.formChanged()

        if (valid) {
          this.formLoading = true

          const startDate = this.ruleForm.dateRange[0]
          const endDate = this.ruleForm.dateRange[1]

          const actionPayload = {
            company_vehicle: this.ruleForm.vehicle_id.join(','),
            date__lte: endDate,
            date__gte: startDate,
          }

          periodicReport.api(actionPayload).then((res) => {
            this.formLoading = false
            this.$emit('result', res)
            this.result = res
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },

  computed: {
    maxDate() {
      const today = new Date()
      return today.toISOString().split('T')[0]
    },
  },
}
</script>
